import React from "react";
import _get from "lodash.get";
import { withRouter } from "react-router-dom";
import JarvisButton from "components/JarvisButton";
import JarvisCard from "components/JarvisCard";
import SectionTitle from "components/SectionTitle";
import Stack from "components/common/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "components/common/IconButton";
import JarvisSubscriptionPlans from "components/JarvisSubscriptionPlans";

import PlanPayment from "containers/PlanPayment";

import { config } from "config/index";
import { localStore } from "stores/localStorage";
import { dateTimeHelper } from "helper/dateTime";
import {
  getPortfolioPlanFrequencies,
  pickPortfolioPlanForAmount,
  pickAllInOnePlan,
} from "helper/subscriptionPlan";
import { getAllInOnePreferredFrequency } from "helper/allInOneSignupParams";

const planFrequencyMessage = {
  MONTHLY:
    "Your Jarvis portfolio subscription auto-renews every month. <br/> You can cancel subscription any time.",
  HALF_YEARLY:
    "Your Jarvis portfolio subscription auto-renews every Half-yearly. <br/> You can cancel subscription any time.",
  YEARLY:
    "Your Jarvis portfolio subscription auto-renews every year. <br/> You can cancel subscription any time.",
  QUARTERLY:
    "Your Jarvis portfolio subscription auto-renews every quarter. <br/> You can cancel subscription any time.",
};

class PlanAndPricingContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: "PLAN_LIST",
      selectedFrequency: null,
      selectedPlanData: {},
      currentInvestmentAmount: null,
      disabledPlanData: {},
    };
  }

  // DidMount
  componentDidMount() {
    // this.fetchCustomerProfileData();
    const {
      onBoardingInvestmentAmount,
      investmentAmount,
      selectedPlanId,
      productCode,
      expiryDate,
    } = this.props;
    const paymentType = _get(
      this.props,
      "location.state.paymentType",
      this.props.paymentType,
    );
    let selectAmount = 0;
    if (paymentType === "RENEWAL" || paymentType === "UPGRADE") {
      selectAmount = onBoardingInvestmentAmount
        ? Number(onBoardingInvestmentAmount)
        : null;
    } else {
      selectAmount = investmentAmount;
    }

    this.props.getSubscriptionPlansAction({ productCode: productCode });

    // Select initial frequency
    const subscriptionFrequencies = this.getSubscriptionPlanFrequencies();
    let firstFrequecy = this.getInitialFrequency(subscriptionFrequencies);
    if (subscriptionFrequencies.length && !this.state.selectedFrequency) {
      this.handleFrequencyChange({ selectedFrequency: firstFrequecy });
    }
    if (paymentType === "UPGRADE") {
      this.disabledPreviousPlan({ selectedPlanId, expiryDate });
    }
    // Auto select plan
    this.autoSelectPlan({
      selectedPlanId: selectedPlanId,
      selectAmount,
      selectedFreq: firstFrequecy,
      changeMode: "init",
    });

    // if(productCode === config.productCodes.ONESTOCK && paymentType != "RENEWAL"){
    //     this.setState({  view : 'PLAN_DETAILS' });
    //     const onestockSelectedPlanData = this.props.subscriptionPlans.find(p => p.planId === this.props.selectedPlanId);
    //     console.log("called", { onestockSelectedPlanData })
    //     this.handlePlanSelection(onestockSelectedPlanData)
    // }
  }

  // DidUpdate
  componentDidUpdate(prevProps, prevState) {
    const subscriptionFrequencies = this.getSubscriptionPlanFrequencies();
    const { selectedFrequency } = this.state;

    if (subscriptionFrequencies.length && !this.state.selectedFrequency) {
      const firstFrequency = this.getInitialFrequency(subscriptionFrequencies);
      this.handleFrequencyChange({
        selectedFrequency: firstFrequency,
      });
    }

    const isAllInOneSubscriber = this.props.sourceType === "ALL_IN_ONE" && (Number(this.props.isAllInOneSubscriptionActive) === 1 || this.props.isAllInOneSubscriptionActive === true);
    if (
      isAllInOneSubscriber &&
      this.props.allInOnePlanFrequency &&
      (prevProps.allInOnePlanFrequency !== this.props.allInOnePlanFrequency ||
       prevProps.isAllInOneSubscriptionActive !== this.props.isAllInOneSubscriptionActive ||
       prevProps.sourceType !== this.props.sourceType)
    ) {
      const targetFrequency = String(this.props.allInOnePlanFrequency).toUpperCase();
      if (subscriptionFrequencies.includes(targetFrequency) && this.state.selectedFrequency !== targetFrequency) {
        this.handleFrequencyChange({ selectedFrequency: targetFrequency });
      }
    }
    if (
      this.props.isAllInOne &&
      this.props.subscriptionPlans.length &&
      this.state.view === "PLAN_LIST"
    ) {
      this.autoSelectPlan({
        selectedPlanId: this.props.selectedPlanId,
        selectAmount: this.props.investmentAmount,
        changeMode: "init",
      });
      this.setState({ view: "PLAN_DETAILS" });
    }

    //  Handle productCode change if(Portfolio <-> Prime)
    if (prevProps.productCode !== this.props.productCode) {
      // console.log(
      //   " productCode changed:",
      //   prevProps.productCode,
      //   "➡",
      //   this.props.productCode
      // );

      // fetch fresh plans
      this.props.getSubscriptionPlansAction({
        productCode: this.props.productCode,
      });

      this.setState({
        selectedPlanData: {},
        selectedFrequency: subscriptionFrequencies.length
          ? subscriptionFrequencies[0]
          : null,
      });

      if (subscriptionFrequencies.length) {
        this.autoSelectPlan({
          selectAmount: this.props.investmentAmount,
          selectedFreq: subscriptionFrequencies[0],
          changeMode: "productCodeChange",
          selectedPlanId: this.props.selectedPlanId,
        });
      }
    }

    // Select Plan on Frequency change
    if (
      prevState.selectedFrequency !== this.state.selectedFrequency &&
      (this.props.productCode !== config.productCodes.ONESTOCK ||
        this.props.productCode !== config.productCodes.SENTIMENT)
    ) {
      let selectedPlanId = this.props.selectedPlanId;
      this.disabledPreviousPlan({ selectedPlanId });
      this.autoSelectPlan({
        selectAmount: this.props.investmentAmount,
        selectedFreq: this.state.selectedFrequency,
        changeMode: "frequency",
        selectedPlanId,
      });
    }

    // Select Plan on Amount change

    if (
      prevProps.investmentAmount !== this.props.investmentAmount &&
      (this.props.productCode !== config.productCodes.ONESTOCK ||
        this.props.productCode !== config.productCodes.SENTIMENT)
    ) {
      this.setState({ currentInvestmentAmount: this.props.investmentAmount });
      this.autoSelectPlan({
        selectAmount: this.props.investmentAmount,
        selectedFreq: selectedFrequency,
        changeMode: "amount",
      });
    }

    const isAllInOneActivePortfolio = 
      this.props.productCode === config.productCodes.PORTFOLIO &&
      this.props.sourceType &&
      String(this.props.sourceType).toUpperCase() === "ALL_IN_ONE" &&
      (String(this.props.isAllInOneSubscriptionActive) === "1" || this.props.isAllInOneSubscriptionActive === true);

    if (
      isAllInOneActivePortfolio &&
      (prevProps.subscriptionPlans !== this.props.subscriptionPlans ||
       prevProps.sourceType !== this.props.sourceType ||
       prevProps.isAllInOneSubscriptionActive !== this.props.isAllInOneSubscriptionActive)
    ) {
      this.autoSelectPlan({
        selectAmount: this.props.investmentAmount,
        selectedFreq: selectedFrequency || subscriptionFrequencies[0],
        changeMode: "allInOneActive",
      });
    }

    const plansJustLoaded =
      !prevProps.subscriptionPlans?.length &&
      this.props.subscriptionPlans?.length > 0;

    if (
      plansJustLoaded &&
      (this.props.productCode === config.productCodes.PORTFOLIO ||
        this.props.productCode === config.productCodes.PRIME)
    ) {
      const frequencies =
        subscriptionFrequencies.length > 0
          ? subscriptionFrequencies
          : getPortfolioPlanFrequencies(this.props.subscriptionPlans);
      const firstFrequency = frequencies[0];

      if (!selectedFrequency && firstFrequency) {
        this.handleFrequencyChange({ selectedFrequency: firstFrequency });
      }

      const hasSelectedPlan =
        this.state.selectedPlanData &&
        Object.keys(this.state.selectedPlanData).length > 0;

      if (!hasSelectedPlan) {
        this.autoSelectPlan({
          selectedPlanId: this.props.selectedPlanId,
          selectAmount: this.props.investmentAmount,
          selectedFreq: selectedFrequency || firstFrequency,
          changeMode: "plansLoaded",
        });
      }
    }
  }

  fetchCustomerProfileData = async () => {
    await this.props.getProfileDataAction();
    return;
  };

  // Auto select Plan based on amount & Frequency.
  autoSelectPlan = ({
    selectedPlanId = "",
    selectAmount,
    selectedFreq,
    changeMode = null,
    // defaultSelectPlanId = 17
  }) => {
    const { subscriptionPlans } = this.props;
    const { selectedPlanData } = this.state;
    let autoSelectedPlan = null;

    const isAllInOneActivePortfolio = 
      this.props.productCode === config.productCodes.PORTFOLIO &&
      this.props.sourceType &&
      String(this.props.sourceType).toUpperCase() === "ALL_IN_ONE" &&
      (String(this.props.isAllInOneSubscriptionActive) === "1" || this.props.isAllInOneSubscriptionActive === true);

    if (isAllInOneActivePortfolio) {
      const activeFreq = selectedFreq || this.state.selectedFrequency;
      if (subscriptionPlans && subscriptionPlans.length > 0) {
        const sortedPlans = subscriptionPlans
          .filter((p) => p.planFrequency === activeFreq)
          .sort((a, b) => Number(a.planSequence || 0) - Number(b.planSequence || 0));
        if (sortedPlans.length > 0) {
          const premiumPlan = sortedPlans[2] || sortedPlans[sortedPlans.length - 1];
          if (selectedPlanData?.planId !== premiumPlan.planId) {
            this.handlePlanSelection(premiumPlan);
          }
          return;
        }
      }
    }

    if (this.props.productCode === config.productCodes.ONESTOCK || this.props.isAllInOne) {
      let selectedPlan;
      if (this.props.isAllInOne) {
        const frequency =
          changeMode === "frequency"
            ? selectedFreq
            : getAllInOnePreferredFrequency() || selectedFreq;
        selectedPlan = pickAllInOnePlan(subscriptionPlans, {
          planId: changeMode === "frequency" ? undefined : selectedPlanId,
          frequency,
        });
      } else if (selectedPlanId) {
        selectedPlan = subscriptionPlans.find(
          (plan) => plan.planId == selectedPlanId,
        );
      } else {
        selectedPlan = subscriptionPlans.find(
          (plan) => plan.planCode === "JO0001",
        );
      }
      if (selectedPlan) {
        return this.setState({ selectedPlanData: selectedPlan });
      }
      return false;
    }
    if (!selectAmount || this.props.productCode === config.productCodes.RMS) {
      let selectedPlan;
      if (
        selectedPlanId &&
        this.props.productCode === config.productCodes.RMS
      ) {
        selectedPlan = subscriptionPlans.find(
          (plan) => plan.planId === selectedPlanId,
        );
        if (selectedPlan) {
          return this.setState({ selectedPlanData: selectedPlan });
        }
      }
      return false;
    }
    if (this.props.productCode === config.productCodes.SENTIMENT) {
      let selectedPlan;
      if (selectedPlanId) {
        selectedPlan = subscriptionPlans.find(
          (plan) => plan.planId === selectedPlanId,
        );
      } else {
        selectedPlan = subscriptionPlans.find(
          // (plan) => plan.planCode === "JO0001"
          (plan) => plan.planCode === "JS0001",
        );
      }
      if (selectedPlan) {
        return this.setState({ selectedPlanData: selectedPlan });
      }
      return false;
    }

    if (
      (this.props.productCode === config.productCodes.PORTFOLIO &&
        this.props.paymentType === "RENEWAL" &&
        selectedPlanId) ||
      (this.props.productCode === config.productCodes.PRIME &&
        this.props.paymentType === "RENEWAL" &&
        selectedPlanId)
    ) {
      let selectedPlan = subscriptionPlans.find(
        (plan) => plan.planId === selectedPlanId,
      );
      if (selectedPlan) {
        return this.setState({ selectedPlanData: selectedPlan });
      }
    }

    if (
      selectedPlanData &&
      Object.keys(selectedPlanData).length > 0 &&
      changeMode === "amount"
    ) {
      let autoSetNotRequired = selectedPlanData.productMap.some((product) => {
        // if (product.productCode === this.props.productCode)
        if (
          product.productCode === config.productCodes.PORTFOLIO ||
          product.productCode === config.productCodes.PRIME
        ) {
          if (
            product.aumLimit === -1 ||
            Number(selectAmount) <= product.aumLimit
          ) {
            return true;
          }
          return false;
        }
      });

      if (autoSetNotRequired) {
        return;
      }
    }

    let freqPlans = subscriptionPlans.filter(
      (p) => p.planFrequency === selectedFreq,
    );
    if (freqPlans && freqPlans.length > 0) {
      freqPlans.some((plan) => {
        return plan.productMap.some((product) => {
          // if (product.productCode === this.props.productCode)
          if (
            product.productCode === config.productCodes.PORTFOLIO ||
            product.productCode === config.productCodes.ONESTOCK ||
            product.productCode === config.productCodes.PRIME ||
            product.productCode === config.productCodes.SENTIMENT
          ) {
            if (
              product.aumLimit === -1 ||
              Number(selectAmount) <= product.aumLimit
            ) {
              autoSelectedPlan = plan;
              return true;
            }
            return false;
          }
        });
      });
    }

    if (selectedPlanId) {
      autoSelectedPlan = subscriptionPlans.find(
        (p) => p.planId === selectedPlanId,
      );
    }

    if (autoSelectedPlan) {
      this.handlePlanSelection(autoSelectedPlan);
    }
  };
  disabledPreviousPlan = ({ selectedPlanId = "", expiryDate = "" }) => {
    const { subscriptionPlans } = this.props;
    const currentDate = dateTimeHelper.sipDate(dateTimeHelper.now());
    const currentYear = dateTimeHelper.format(currentDate, "$YYYY");
    const currentMonth = dateTimeHelper.format(currentDate, "$MM");
    const customerPlanExpiryDate = dateTimeHelper.sipDate(expiryDate);
    const customerPlanExpiryMonth = dateTimeHelper.format(
      customerPlanExpiryDate,
      "$MM",
    );
    const customerPlanExpiryYear = dateTimeHelper.format(
      customerPlanExpiryDate,
      "$YYYY",
    );
    let selectedPlan;
    if (selectedPlanId) {
      selectedPlan = subscriptionPlans.find(
        (plan) => plan.planId === selectedPlanId,
      );
    }
    if (
      selectedPlan &&
      (currentMonth !== customerPlanExpiryMonth ||
        currentYear !== customerPlanExpiryYear)
    ) {
      return this.setState({ disabledPlanData: selectedPlan });
    }
    return false;
  };

  getSubscriptionPlanFrequencies = () => {
    const planFrequency = [];
    if (this.props.subscriptionPlans && this.props.subscriptionPlans.length) {
      this.props.subscriptionPlans.forEach((plan) => {
        if (!planFrequency.includes(plan.planFrequency)) {
          planFrequency.push(plan.planFrequency);
        }
      });
    }
    const frequencies = planFrequency.reverse();
    if (this.props.isAllInOne) {
      const urlFrequency = getAllInOnePreferredFrequency();
      if (urlFrequency && frequencies.includes(urlFrequency)) {
        return [urlFrequency];
      }
    }
    return frequencies;
  };

  getInitialFrequency = (subscriptionFrequencies = []) => {
    const isAllInOneSubscriber =
      this.props.sourceType === "ALL_IN_ONE" &&
      (Number(this.props.isAllInOneSubscriptionActive) === 1 ||
        this.props.isAllInOneSubscriptionActive === true);
    if (isAllInOneSubscriber && this.props.allInOnePlanFrequency) {
      const targetFrequency = String(
        this.props.allInOnePlanFrequency,
      ).toUpperCase();
      if (subscriptionFrequencies.includes(targetFrequency)) {
        return targetFrequency;
      }
    }
    if (this.props.isAllInOne) {
      const urlFrequency = getAllInOnePreferredFrequency();
      if (urlFrequency && subscriptionFrequencies.includes(urlFrequency)) {
        return urlFrequency;
      }
    }
    return subscriptionFrequencies[0];
  };

  handleFrequencyChange = ({ selectedFrequency }) => {
    this.setState({ selectedFrequency });
  };

  handlePlanSelection = (planData) => {
    if (this.props.productCode === config.productCodes.PRIME) {
      this.props.updatePrimeOnboardingDataAction({ planId: planData.planId });
    } else {
      this.props.updateOnboardingDataAction({ planId: planData.planId });
    }

    this.setState({ selectedPlanData: planData }, () => {
      if (this.props && this.props.onPlanSelection) {
        this.props.onPlanSelection(planData);
      }
    });
  };

  handleContinue = () => {
    const { productCode } = this.props;
    let productOverview = "";
    localStore.setActiveProduct(productCode);
    switch (productCode) {
      case config.productCodes.PORTFOLIO:
        productOverview = "/jarvis-portfolio/onboarding/overview";
        break;
      case config.productCodes.RMS:
        productOverview = "/jarvis-rms/onboarding/overview";
        break;
      case config.productCodes.ONESTOCK:
        productOverview = "/jarvis-onestock/onboarding/overview";
        break;
      case config.productCodes.PRIME:
        productOverview = "/jarvis-prime/onboarding/overview";
        break;
      case config.productCodes.SENTIMENT:
        productOverview = "/sentiment-tracker/onboarding/overview";
        break;
      default:
        return;
    }

    if (productOverview) {
      this.props.history.push(productOverview);
    }
  };

  handlePaymentClick = (paymentData, isOnetime) => {
    //event-tracker: Initial -> proceed to pay.
    // tracker.initial.iProceedToPay();
    // this.setState({ selectedPlanData: null, confirmDialogOpen: false });

    localStore.resetPaymentInitiated();
    const isOnetimePayment = isOnetime || this.props.isAllInOne;
    this.props.history.push({
      pathname: isOnetimePayment ? "/customer/onetime-payment" : "/customer/payment",
      state: {
        returnURI: this.props.isAllInOne ? "/all-in-one" : undefined,
        productCode: this.props.isAllInOne ? "ALL_IN_ONE" : this.props.productCode,
        transactionType: this.props.isAllInOne ? "ALL_IN_ONE" : null,
        customerValueAddedPlanId: paymentData.customerValueAddedPlanId || this.props.customerValueAddedPlanId,
        planId: paymentData.planId
          ? paymentData.planId
          : this.state.selectedPlanData.planId,
        offerCode: paymentData.offerCode,
        paymentMethod: paymentData.paymentMethod,
        paymentMethodOption: paymentData.paymentMethodOption,
        paymentType: this.props.paymentType,
        paymentDetails: {
          authType: paymentData.authType,
          accountNumber: paymentData.accountNumber,
          accountType: paymentData.accountType,
          accountHolderName: paymentData.accountHolderName,
          ifscCode: paymentData.ifscCode,
        },
      },
    });
  };

  handlePlanAndPricingClick = () => {
    if (!Object.keys(this.props.renewalPricingDetails).length) {
      this.props.getRenewSubscriptionAction();
    }
    this.setState({ selectedPlanData: null, selectedFrequency: null });
  };

  handleBackToProfile = () => {
    const returnURI = _get(
      this.props,
      "location.state.returnURI",
      "/customer/dashboard",
    );
    this.props.history.replace(returnURI);
  };

  handleBackClick = () => {
    const { screenType, productCode, paymentType } = this.props;
    let screenParam = "GO_BACK";
    if (productCode === config.productCodes.RMS && paymentType === "INITIAL") {
      screenParam = screenType.CONFIRM_PORTFOLIO;
    }
    if (
      productCode === config.productCodes.ONESTOCK &&
      paymentType === "INITIAL"
    ) {
      screenParam = screenType.RISK_SUMMARY;
    }
    if (
      productCode === config.productCodes.SENTIMENT &&
      paymentType === "INITIAL"
    ) {
      // NEED TO CHANGE THIS TO PRODUCT PAGE
      screenParam = screenType.RISK_SUMMARY;
    }
    return this.props.handleScreenChange(screenParam);
  };

  render() {
    const {
      subscriptionPlans,
      currentPortfolioCount,
      currentStockCount,
      renewalPricingDetails,
      investmentAmount,
      productTitle,
      diasbleCircle,
      productButtonType = false,
      productButtonName,
      onestockData = false,
    } = this.props;

    const {
      selectedFrequency,
      view,
      selectedPlanData,
      confirmDialogOpen,
      disabledPlanData,
    } = this.state;
    const subscriptionFrequencies = this.getSubscriptionPlanFrequencies();

    const paymentType = _get(
      this.props,
      "location.state.paymentType",
      this.props.paymentType,
    );

    // jarvis plan and pricing padding
    let jCardPadding = "20px 24px";

    if (paymentType === "RENEWAL" || paymentType === "UPGRADE") {
      jCardPadding = "20px 0px";
    } else if (
      this.props.productCode === config.productCodes.RMS ||
      this.props.productCode === config.productCodes.ONESTOCK ||
      this.props.productCode === config.productCodes.SENTIMENT
    ) {
      jCardPadding = "20px 0px";
    }

    return (
      <JarvisCard
        sx={{
          padding: jCardPadding,
          background:
            paymentType === "RENEWAL" || paymentType === "UPGRADE"
              ? "unset"
              : "unset",
        }}
      >
        {view === "PLAN_LIST" && (
          <Stack>
            {this.props.productCode === config.productCodes.RMS ||
            paymentType === "RENEWAL" ||
            paymentType === "UPGRADE" ? (
              <SectionTitle
                sx={{
                  display: { xs: "flex", md: "flex" },
                  mb: { xs: 2, md: 2 },
                }}
                heading="Plans & Pricing"
                startIcon={
                  this.props.productCode === config.productCodes.RMS ? null : (
                    <IconButton onClick={this.handleBackClick}>
                      <ArrowBackIcon sx={{ fontSize: 20, color: "#222B3E" }} />
                    </IconButton>
                  )
                }
              />
            ) : null}
            <JarvisSubscriptionPlans
              onBackClick={this.handleBackToProfile}
              subscriptionPlans={subscriptionPlans}
              subscriptionFrequencies={subscriptionFrequencies}
              onFrequencyChange={this.handleFrequencyChange}
              onPlanSelect={this.handlePlanSelection}
              selectedFrequency={selectedFrequency}
              currentPortfolioCount={currentPortfolioCount}
              currentStockCount={currentStockCount}
              currentInvestmentAmount={
                investmentAmount || renewalPricingDetails?.investmentAmount
              }
              selectedPlanData={selectedPlanData}
              disabledPlanData={disabledPlanData}
              paymentType={paymentType}
              confirmDialog={{
                open: confirmDialogOpen,
                title: `Selected Plan: <span style="white-space: nowrap">${selectedPlanData?.planName}</span>`,
                content: planFrequencyMessage[selectedFrequency],
                onConfirm: () => this.handlePaymentClick(),
                onCancel: () =>
                  this.setState({
                    confirmDialogOpen: false,
                    selectedPlanData: null,
                  }),
              }}
              onestockData={onestockData ? true : false}
              productTitle={productTitle ? productTitle : "Select the plan"}
              diasbleCircle={diasbleCircle ? diasbleCircle : ""}
              sourceType={this.props.sourceType}
              isAllInOneSubscriptionActive={this.props.isAllInOneSubscriptionActive}
              allInOnePlanFrequency={this.props.allInOnePlanFrequency}
            />
            {productButtonType ? (
              <Stack
                my={3}
                sx={{ maxWidth: { xs: "90vw", md: "unset" } }}
                alignItems="end"
              >
                <JarvisButton
                  sx={{ width: { xs: "100%", md: "unset" } }}
                  onClick={() => this.handleContinue()}
                >
                  {productButtonName}
                </JarvisButton>
              </Stack>
            ) : null}
            {(this.props.productCode === config.productCodes.RMS &&
              !productButtonType &&
              paymentType === "INITIAL") ||
            (this.props.productCode === config.productCodes.ONESTOCK &&
              !productButtonType &&
              paymentType === "INITIAL") ||
            (this.props.productCode === config.productCodes.RMS &&
              paymentType === "RENEWAL") ||
            (this.props.productCode === config.productCodes.PORTFOLIO &&
              paymentType === "RENEWAL") ||
            (this.props.productCode === config.productCodes.PORTFOLIO &&
              paymentType === "UPGRADE") ||
            (this.props.productCode === config.productCodes.ONESTOCK &&
              paymentType === "UPGRADE") ||
            (this.props.productCode === config.productCodes.RMS &&
              paymentType === "UPGRADE") ||
            (this.props.productCode === config.productCodes.PRIME &&
              paymentType === "RENEWAL") ||
            (this.props.productCode === config.productCodes.PRIME &&
              paymentType === "UPGRADE") ||
            (this.props.productCode === config.productCodes.ONESTOCK &&
              paymentType === "RENEWAL") ||
            (this.props.productCode === config.productCodes.SENTIMENT &&
              !productButtonType &&
              paymentType === "INITIAL") ||
            (this.props.productCode === config.productCodes.SENTIMENT &&
              paymentType === "RENEWAL") ||
            (this.props.productCode === config.productCodes.SENTIMENT &&
              paymentType === "UPGRADE") ? (
              <Stack
                sx={{
                  background: "unset",
                  width: { xs: "100%", md: "unset" },
                  justifyContent: { xs: "center", md: "unset" },
                  alignItems: { xs: "center", md: "unset" },
                }}
              >
                <Stack
                  mt={3}
                  alignItems="end"
                  sx={{
                    mb: { xs: "unset", md: 3 },
                    position: { xs: "fixed", md: "unset" },
                    bottom: { xs: "10px", md: "unset" },
                    width: { xs: "90vw", md: "unset" },
                    paddingBottom: {
                      xs: "calc(var(--safe-area-inset-bottom) + 12px) !important",
                    },
                  }}
                >
                  <JarvisButton
                    disabled={
                      paymentType !== "UPGRADE"
                        ? !selectedPlanData ||
                          !Object.values(selectedPlanData).length
                        : Object.values(disabledPlanData).length &&
                          disabledPlanData?.planId === selectedPlanData?.planId
                    }
                    sx={{ width: { xs: "100%", md: "unset" } }}
                    onClick={() => this.setState({ view: "PLAN_DETAILS" })}
                  >
                    Continue
                  </JarvisButton>
                </Stack>
              </Stack>
            ) : null}
          </Stack>
        )}

        {view === "PLAN_DETAILS" && (
          <PlanPayment
            paymentType={paymentType}
            onboardingPlanId={selectedPlanData.planId}
            navigatePreviousScreen={() => this.setState({ view: "PLAN_LIST" })}
            onPayNowClick={this.handlePaymentClick}
            byPassRecurringPayment={
              this.props.productCode === config.productCodes.PRIME
                ? true
                : false
            }
            oneTimePayment={this.props.oneTimePayment || this.props.isAllInOne}
            isAllInOne={this.props.isAllInOne}
            initialCouponCode={this.props.initialCouponCode}
            customerValueAddedPlanId={this.props.customerValueAddedPlanId}
          />
        )}
      </JarvisCard>
    );
  }
}

export default withRouter(PlanAndPricingContainer);
